import * as React from "react";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { SectionHeader } from "../../../Common/SharedComponents";

interface IFinancialAdviceProps {
    data: any;
}

interface IFinancialAdviceState {}

export class FinancialAdvice extends FormComponent<IFinancialAdviceProps, IFinancialAdviceState> {
    constructor(props: any) {
        super(props);
    }

    public render(): JSX.Element {
        const { data } = this.props;
        return (
            <>
                <h2 className="layout-styleguide-heading pb-12">Financial advice</h2>
                <div className="row">
                    <span className="col-sm-6 h4">Did you give financial advice?</span>
                    <span className="col-sm-6 pl-0" data-test="clientage">
                        {data?.DrawdownIncomeAmendmentInstruction?.AdviceGiven ? "Yes" : "No"}
                    </span>
                </div>
            </>
        );
    }
}
